type JSONCSVMapping = {
  field_mappings: JSONFieldMapping[];
  id: Maybe<number>;
  is_active: boolean;
  name: string;
};

type CSVMapping = {
  fieldMappings: FieldMapping[];
  id: Maybe<number>;
  isActive: boolean;
  name: string;
};

type JSONFieldMapping = {
  col_idx: number;
  col_name: string;
  field: JSONField;
};

type FieldMapping = {
  colIdx: number;
  colName: string;
  field: Field;
};

type JSONField = {
  id: number;
  is_required: boolean;
  name: string;
};

type Field = {
  id: number;
  isRequired: boolean;
  name: string;
};

const fieldFromJSON = (jsonField: JSONField): Field => ({
  id: jsonField.id,
  isRequired: jsonField.is_required,
  name: jsonField.name,
});

const fieldToJSON = (field: Field): JSONField => ({
  id: field.id,
  is_required: field.isRequired,
  name: field.name,
});

const fieldMappingFromJSON = (jsonFieldMapping: JSONFieldMapping): FieldMapping => ({
  colIdx: jsonFieldMapping.col_idx,
  colName: jsonFieldMapping.col_name,
  field: fieldFromJSON(jsonFieldMapping.field),
});

const fieldMappingToJSON = (fieldMapping: FieldMapping): JSONFieldMapping => ({
  col_idx: fieldMapping.colIdx,
  col_name: fieldMapping.colName,
  field: fieldToJSON(fieldMapping.field),
});

const fromJSON = (jsonCSV: JSONCSVMapping): CSVMapping => ({
  fieldMappings: jsonCSV.field_mappings.map(fieldMappingFromJSON),
  id: jsonCSV.id,
  isActive: jsonCSV.is_active,
  name: jsonCSV.name,
});

export default CSVMapping;

export { Field, FieldMapping, JSONCSVMapping, fieldMappingToJSON, fromJSON };
